import TimeTableCreate from "@/controllers/timetable/timetable-create.js";
import axios from "axios";
import store from "@/store";
import {
  required
} from "vuelidate/lib/validators";

export default {
  extends: TimeTableCreate,
  name: 'timetableCreate',

  data() {
    return {
      ...TimeTableCreate.data.call(this),
      templateArr: null,
      template_id: null,
      subjectRows: new Array(7).fill([]).map(() => new Array(10).fill("")),
      teacherRows: new Array(7).fill([]).map(() => new Array(10).fill("")),
      teacherOptionsByCell: {},
      teacherMap: {},
      subjectChangeCounter: 0,
    };
  },

  validations() {
    return {
      ...TimeTableCreate.validations,
      acd_year_id: { required },
      class_id: { required },
      template_id: { required }
    };
  },

  methods: {
    getTemplates() {
      this.isLoading = true;
      axios.get('/timetableMeta/templates', {
        params: {
          campus_id: store.state.user.campus_id,
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Template'
          }];
          const templates = res.data.templates.map(t => ({
            'id': t.id,
            'text': t.name
          }));
          this.templateArr = $defaultSelectOption.concat(templates);
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    changeTemplateEvent(templateId) {
      if (!templateId || templateId == 0) {
        this.timeCount = 0;
        this.dayCount = 0;
        this.days = null;
        this.time = null;
        return;
      }
      this.subjectRows = new Array(7).fill([]).map(() => new Array(10).fill(""));
      this.teacherRows = new Array(7).fill([]).map(() => new Array(10).fill(""));
      this.teacherOptionsByCell = {};
      this.isLoading = true;
      this.getTimetableMetaByTemplate(templateId);
    },

    getTimetableMetaByTemplate(templateId) {
      this.isLoading = true;
      axios.get("/timetableMeta/getDataForTimetableByTemplate/" + templateId)
        .then((response) => {
          this.days = response.data.data[0];
          this.time = response.data.data[1];
          this.dayCount = this.days.length;
          this.timeCount = this.time.length;
          this.subjectRows = Array.from({ length: this.dayCount }, () =>
            Array.from({ length: this.timeCount }, () => "")
          );
          this.teacherRows = Array.from({ length: this.dayCount }, () =>
            Array.from({ length: this.timeCount }, () => "")
          );
          this.teacherOptionsByCell = {};
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    changeClassEvent(classId) {
      this.class_id = classId;
      this.template_id = null;
      this.templateArr = null;
      this.subjectRows = new Array(7).fill([]).map(() => new Array(10).fill(""));
      this.teacherRows = new Array(7).fill([]).map(() => new Array(10).fill(""));
      this.teacherOptionsByCell = {};
      this.teacherMap = {};
      this.getTemplates();
      this.getSubjectByClassId(classId);
    },

    changeAcademicYearEvent(acdYearId) {
      this.class_id = null;
      this.template_id = null;
      this.templateArr = null;
      this.timeCount = 0;
      this.getClass(acdYearId);
    },

    getSubjectByClassId(classId) {
      axios.get("/class/subjectByClassId/" + classId, {
        params: {
          acd_year_id: this.acd_year_id,
          campus_id: this.$store.state.user.campus_id
        }
      })
      .then((response) => {
        this.subjectArr = response.data.subjectArr[0];
        this.teacherMap = response.data.teacherMap || {};
        this.isLoading = false;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    /**
     * Returns the teacher options for a cell from the cache.
     */
    getTeacherOptionsForCell(rowIndex, colIndex) {
      const key = `${rowIndex}_${colIndex}`;
      return this.teacherOptionsByCell[key] || [];
    },

    /**
     * Returns the validation error message for the teacher dropdown at the given cell.
     * Maps (rowIndex, colIndex) back to the items[] index used when building the request,
     * then looks up `items.{index}.subject_teacher_id` in validationErrors.
     */
    getSubjectTeacherError(rowIndex, colIndex) {
      const timeCount = this.timeCount || (this.time ? this.time.length : 0);
      if (!timeCount) return null;
      const itemsIndex = rowIndex * timeCount + colIndex;
      const key = `items.${itemsIndex}.subject_teacher_id`;
      const messages = this.validationErrors?.[key];
      return Array.isArray(messages) && messages.length ? messages[0] : null;
    },

    /**
     * When the subject dropdown changes, look up the teacher options
     * from the cached teacherMap (loaded with subjects) and reset the
     * previously-selected teacher for this cell.
     * Increments subjectChangeCounter so the subject <Select2Multiple>
     * is force-remounted, which is required because the Select2 jQuery
     * wrapper does not properly re-emit @change when the same value is
     * reselected after a different option.
     */
    onSubjectChange(rowIndex, colIndex, selectedSubjectId) {
      this.clearValidationErrors();
      const key = `${rowIndex}_${colIndex}`;
      this.$set(this.teacherRows[rowIndex], colIndex, '');
      this.subjectChangeCounter += 1;
      if (!selectedSubjectId || selectedSubjectId === '0' || selectedSubjectId === 0) {
        this.$set(this.teacherOptionsByCell, key, []);
        return;
      }
      this.$set(this.teacherOptionsByCell, key, this.teacherMap[selectedSubjectId] || []);
    },

    create() {
      this.submitted = true;
      this.clearValidationErrors();
      if (this.$v.$invalid || !this.days || !this.time || this.timeCount == 0) {
        return;
      }

      this.isLoading = true;
      const preparedData = [];
      for (let rowIndex = 0; rowIndex < this.days.length; rowIndex++) {
        for (let columnIndex = 0; columnIndex < this.time.length; columnIndex++) {
          const dayId = this.days[rowIndex].id;
          const timeId = this.time[columnIndex].id;
          const subjectId = this.subjectRows[rowIndex][columnIndex];
          const subjectTeacherId = this.teacherRows[rowIndex][columnIndex];
          const rowData = {
            day_id: dayId,
            time_id: timeId,
          };
          if (subjectId !== undefined && subjectId !== '' && subjectId !== '0' && subjectId !== 0) {
            rowData.subject_id = subjectId;
          }
          if (subjectTeacherId !== undefined && subjectTeacherId !== '' && subjectTeacherId !== '0' && subjectTeacherId !== 0) {
            rowData.subject_teacher_id = subjectTeacherId;
          }
          preparedData.push(rowData);
        }
      }

      axios.post("/timetable/create", {
        items: preparedData,
        class_id: this.class_id,
        template_id: this.template_id,
        login_id: this.$store.state.user.id
      })
        .then(response => {
          if (response.data.status == 200) {
            this.$notification.success("Timetable Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "timetableList"
            });
          }
        })
        .catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else if (error.response && error.response.status == 422) {
            this.printValidationError(error.response);
            this.$notification.error(error.response.data.message || "Cannot create timetable", {
              timer: 3,
              position: "bottomCenter"
            });
            this.isLoading = false;
          }
        });
    },
  },

  mounted() {
    this.getCurrentPeriodList();
    // Watch subjectRows for changes (backup in case Select2 @change doesn't fire
    // on reselecting the same value after switching to a different subject).
    // Skips the initial load by ignoring rows that are being initialized
    // (oldRows[r] is undefined).
    this.$watch(
      () => this.subjectRows.map(row => row.slice()),
      (newRows, oldRows) => {
        if (!newRows || !newRows.length || !oldRows || !oldRows.length) return;
        for (let r = 0; r < newRows.length; r++) {
          if (!oldRows[r]) continue;
          for (let c = 0; c < newRows[r].length; c++) {
            const newVal = newRows[r][c];
            const oldVal = oldRows[r][c];
            if (newVal !== oldVal && newVal) {
              this.onSubjectChange(r, c, newVal);
            }
          }
        }
      },
      { deep: true }
    );
  },
};
